<template>
  <a class="event-link" target="_blank" :href="result.resultURL">
    <div class="event-card">
      <span>{{ result.username }} - {{ result.usermail }} - {{ result.created }}</span>
      <div class="buttons">
        <button @click="createCSV(result.id, result.accessUserID, result.accessUserToken, $event)">CSV</button>
        <button style="margin-left: 5px"  @click="createWord(result.id, result.accessUserID, result.accessUserToken, $event)">Word</button>
      </div>
    </div>
  </a>
</template>

<script>
import ApiService from "@/services/ApiService";

export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  methods: {
    createCSV: function (id, user_id, user_token, event){
      event.preventDefault();
      ApiService.getCSV(id, user_id, user_token)
          .then(response => {
            console.log(response.data);
            window.open(response.data.url);
          })
          .catch(error => {
            console.log(error)
          })
    },
    createWord: function (id, user_id, user_token, event){
      event.preventDefault();
      ApiService.getWord(id, user_id, user_token)
          .then(response => {
            console.log(response.data);
            window.open(response.data.url);
          })
          .catch(error => {
            console.log(error)
          })
    }
  }
}
</script>

<style scoped>
.event-card {
  padding: 10px;
  width: 480px;
  cursor: pointer;
  border: 1px solid #39495c;
  margin-bottom: 10px;
}

.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2);
}

.event-link {
  color: #2c3e50;
  text-decoration: none;
}

.buttons{
  margin-top: 5px;
}
</style>
